import { render, staticRenderFns } from "./V2OrderLogs.vue?vue&type=template&id=257c1ec9&scoped=true&"
import script from "./V2OrderLogs.vue?vue&type=script&lang=js&"
export * from "./V2OrderLogs.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderLogs.vue?vue&type=style&index=0&id=257c1ec9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257c1ec9",
  null
  
)

export default component.exports